import { Box, Grid, Tooltip, Typography } from "@mui/material";
import { BOOKING_STATUS_TEXT } from "constants/general";
import moment from "moment";
import { useAppSelector } from "store/appHooks";
import { convertPrice } from "utils/currency.util";

const DetailItem = ({ label, value }: any) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography
        sx={{
          color: "#A2A2A2",
          fontWeight: 400,
          fontSize: "15px",
          lineHeight: "28px",
          //   width: "30%",
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          color: "#323232",
          fontWeight: 500,
          fontSize: "15px",
          lineHeight: "28px",
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

const SummaryLineItem = ({ label, value }: any) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography
        sx={{
          color: "#A2A2A2",
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "30px",
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          color: "#323232",
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "30px",
        }}
      >
        {new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          currencyDisplay: "narrowSymbol",
        }).format(value)}
      </Typography>
    </Box>
  );
};

const BookingInfo = () => {
  const { personalRentalReducer } = useAppSelector((state) => state);
  const { details }: any = personalRentalReducer;
  const paymentDetails = details?.booking_payments?.[0];
  return (
    <Box
      sx={{
        padding: "15px",
        borderRadius: "10px",
        border: "1px solid #E2E2E2",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: "30px",
          color: "#2A2A2A",
        }}
      >
        Booking Info
      </Typography>
      <Box sx={{ my: "10px" }}>
        <Grid container spacing={2}>
          <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
            <DetailItem label="Order ID -" value={`#${details?.id}`} />
          </Grid>
          <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
            <DetailItem
              label="Order Date -"
              value={moment(details?.created_at).format("MMM DD, yyyy hh:mm a")}
            />
          </Grid>
          <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
            <DetailItem
              label="Order Date -"
              value={convertPrice(details?.booking_payments?.[0]?.total)}
            />
          </Grid>
          <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
            <DetailItem
              label="Status -"
              value={BOOKING_STATUS_TEXT[details?.booking_status]}
            />
          </Grid>
        </Grid>
      </Box>

      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: "64px",
          color: "#2A2A2A",
        }}
      >
        Delivery Address
      </Typography>
      <Typography
        sx={{
          color: "#A2A2A2",
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "22px",
          //   my: "10px",
        }}
      >
        {[
          details?.address?.address_line_1,
          details?.address?.address_line_2,
          details?.address?.city,
          details?.address?.state,
          details?.address?.zipcode,
        ]
          .filter((r) => r)
          .join(", ")}
      </Typography>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: "30px",
          color: "#2A2A2A",
          mt: "20px",
          mb: "15px",
        }}
      >
        Order Summary
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        <SummaryLineItem label="Sub total" value={paymentDetails?.subtotal} />
        <SummaryLineItem
          label="Haystackers fee"
          value={paymentDetails?.haystacker_fees}
        />
        <SummaryLineItem label="Insurance" value={paymentDetails?.insurance} />
        <SummaryLineItem
          label="Security Deposit"
          value={paymentDetails?.security_deposit}
        />
        <SummaryLineItem label="Taxes" value={paymentDetails?.taxes} />
        <Box sx={{ height: "1px", background: "#E2E2E2", my: "15px" }} />

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Typography
              sx={{
                color: "#2A2A2A",
                fontSize: "20px",
                fontWeight: 600,
                lineHeight: "30px",
              }}
            >
              Total
            </Typography>
            <Tooltip
              title="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. "
              arrow
            >
              <img src="/assets/img/icons/info_circle.svg" alt="" />
            </Tooltip>
          </Box>
          <Typography
            color="primary"
            sx={{ fontSize: "20px", lineHeight: "30px", fontWeight: 600 }}
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              currencyDisplay: "narrowSymbol",
            }).format(paymentDetails?.total)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BookingInfo;
